import { OrderStatus } from '#/__generated__/graphql/graphql';

// TODO: Add more colour to the theme
export function getColorByStatus(status: string) {
  switch (status) {
    case OrderStatus.OrderDraft:
    case OrderStatus.OrderPending:
      return 'amber';
    case OrderStatus.OrderCancelled:
      return 'gray';
    case OrderStatus.OrderPaymentDue:
    case OrderStatus.OrderProblem:
      return 'red';
    case OrderStatus.OrderDelivered:
      return 'green';
    case OrderStatus.OrderProcessing:
      return 'blue';
    case OrderStatus.OrderInTransit:
      return 'primary';
  }
}

export function normalizeOrderStatus(status: string) {
  switch (status) {
    case 'cancelled':
      return OrderStatus.OrderCancelled;
    case 'delivered':
      return OrderStatus.OrderDelivered;
    case 'draft':
      return OrderStatus.OrderDraft;
    case 'in_transit':
      return OrderStatus.OrderInTransit;
    case 'payment_due':
      return OrderStatus.OrderPaymentDue;
    case 'pending':
      return OrderStatus.OrderPending;
    case 'problem':
      return OrderStatus.OrderProblem;
    case 'processing':
      return OrderStatus.OrderProcessing;
    default:
      throw new Error(`Invalid order status type: ${status}`);
  }
}

export function denormalizeOrderStatus(status: OrderStatus) {
  switch (status) {
    case OrderStatus.OrderCancelled:
      return 'cancelled';
    case OrderStatus.OrderDelivered:
      return 'delivered';
    case OrderStatus.OrderDraft:
      return 'draft';
    case OrderStatus.OrderInTransit:
      return 'in_transit';
    case OrderStatus.OrderPaymentDue:
      return 'payment_due';
    case OrderStatus.OrderPending:
      return 'pending';
    case OrderStatus.OrderProblem:
      return 'problem';
    case OrderStatus.OrderProcessing:
      return 'processing';
    default:
      throw new Error(`Invalid order status type: ${status}`);
  }
}
